import { FEATURE_FLAG } from '@qality/common-config';

import { ExecutionStatus, ExecutionStatusSummary } from './ExecutionStatus';
import { TestCaseInCycle } from './TestCaseInCycle';
import { Version } from './Version';

export type TestCycleProject = {
  id: number | string;
  iconUrl: string;
  name: string;
  key: string;
};

export type TestCycleForExecution = {
  testCycleId?: number;
  testCaseInCycleId: number;
  name: string;
  projectId: string;
  projectKey: string;
  testExecutionId?: number;
  createdDate: string;
  executionAssignee: string;
  statusObject: ExecutionStatus;
  projectAvatarUrl: string;
  executionAssigneeAvatarUrl?: string;
  executionAssigneeName?: string;
};

export type AdHocExecution = {
  name: string;
};

export type TestCycleForExecutionResponse = {
  content: Array<{
    testCycleId?: number;
    testCaseInCycleId: number;
    name: string;
    projectId: string;
    projectKey: string;
    testExecutionId?: number;
    createdDate: string;
    executionAssignee: string;
    statusObject: ExecutionStatus;
  }>;
};

export type TestCycleOption = {
  value: TestCycleForExecution;
  label: string;
};

export type TestCycleAsOption = {
  value: number;
  label: string;
} & TestCycle;

export type TestCycleRequestData = {
  fields: {
    name: string;
    versionId?: number | string;
    dueDate?: string;
    comment: string;
    isClosed?: boolean;
  };
};

export default class TestCycle {
  id: number;
  name: string;
  testCases: Array<TestCaseInCycle>;
  project: TestCycleProject;
  version: Version;
  status?: ExecutionStatusSummary;
  created: string;
  dueDate?: string;
  comment: string;
  canEdit?: boolean;
  isClosed?: boolean;
  testCaseExistInCycle?: boolean;
  numberOfTestCases: number;

  constructor(
    id: number,
    name: string,
    testCases: Array<TestCaseInCycle>,
    project: {
      id: number | string;
      iconUrl: string;
      name: string;
      key: string;
    },
    version: Version,
    status: ExecutionStatusSummary,
    created: string,
    dueDate: string,
    comment: string,
    canEdit = false,
    isClosed = false,
    numberOfTestCases: number,
    testCaseExistInCycle = false
  ) {
    this.id = id;
    this.name = name;
    this.project = project;
    this.version = version;
    this.status = status;
    this.created = created;
    this.dueDate = dueDate;
    this.testCases = testCases;
    this.comment = comment;
    this.canEdit = canEdit;
    this.isClosed = isClosed;
    this.numberOfTestCases = numberOfTestCases;
    this.testCaseExistInCycle = testCaseExistInCycle;
  }

  getRequestData(): TestCycleRequestData {
    return {
      fields: {
        name: this.name,
        ...(this.version ? { versionId: this.version.id } : {}),
        ...(this.dueDate ? { dueDate: this.dueDate } : {}),
        comment: this.comment,
        ...(FEATURE_FLAG.isPremium ? { isClosed: this.isClosed } : {}),
      },
    };
  }
}
